export default __webpack_public_path__ + "static/media/biswap.58fe7b6b.svg";